export const lazyLoader = () => {
    return {
        limit: 10,
        offset: 0,
        page: 1,
        isLazyLoading: false,
        fetchRequest: () => null,
        lazyInit(elementToObserve) {
            // @ts-ignore
            const loading = this.loading != undefined ? this.loading : this.isLoadingProducts;
            if (window.IntersectionObserver) {
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            if (!this.isLazyLoading && !loading) {
                                this.isLazyLoading = true;
                                this.page += 1;
                                this.offset += this.limit;
                                this.fetchRequest();
                            }
                        }
                    });
                }, { rootMargin: '0px', threshold: 1.0 });
                observer.observe(elementToObserve);
            }
        },
    };
};
